import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
const apiUrl = import.meta.env.VITE_API_URL;

const FrameShapeFilter2 = ({ categorySlug, subcategorySlug }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [shapes, setShapes] = useState([]);

  useEffect(() => {
    axios.get(`${apiUrl}/api/shapes`).then(response => {
      const shapes = response.data.map(shape => ({
        id: shape.id,
        title: i18n.language === 'ar' ? shape.title_ar : shape.title_en,
        image: shape.image,
      }));
      setShapes(shapes);
    }).catch(error => console.error('Error fetching shapes:', error));
  }, [i18n.language]);

  const handleShapeClick = (shapeId) => {
    const currentParams = new URLSearchParams(searchParams);
    if (currentParams.get('shape_id') === shapeId?.toString()) {
      currentParams.delete('shape_id');
    } else if (shapeId) {
      currentParams.set('shape_id', shapeId);
    }

    const slug = subcategorySlug || categorySlug;
    if (!slug) {
      return;
    }
    const type = subcategorySlug ? 'subcategory' : 'category';
    navigate(`/products/${type}/${slug}?${currentParams.toString()}`);
  };

  return (
    <div className="sidebar-single-area">
      <h3 className="sidebar-single-area__title">{t('Frame Shape')}</h3>
      <ul className="frame-shape">
        <li className="shape-item">
          <a href="#" onClick={(e) => { e.preventDefault(); handleShapeClick(null); }}>
            <div className="fz-shape-txt">
              <span>{t('All')}</span>
            </div>
          </a>
        </li>
        {shapes.map((shape) => (
          <li className="shape-item" key={shape.id}>
            <a href="#" onClick={(e) => { e.preventDefault(); handleShapeClick(shape.id); }}>
              <div className="fz-shape-img">
                <img src={`${apiUrl}/uploads/${shape.image || ''}`} alt={shape.title} />
              </div>
              <div className="fz-shape-txt">
                <span>{shape.title || ''}</span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FrameShapeFilter2;